const requested = (store, eventDateId) => {
    const eventDateRelatedNews = {
        ...store.getState().relatedNews,
        [eventDateId]: {
            isFetching: true,
            fetchError: false,
            data: null,
        },
    };
    store.setState({
        relatedNews: eventDateRelatedNews,
    });
};

const received = (store, response, eventDateId) => {
    const eventDateRelatedNews = {
        ...store.getState().relatedNews,
        [eventDateId]: {
            isFetching: false,
            fetchError: false,
            data: response.Values,
        },
    };
    store.setState({
        relatedNews: eventDateRelatedNews,
    });
};

const error = (store, eventDateId) => {
    const eventDateRelatedNews = {
        ...store.getState().relatedNews,
        [eventDateId]: {
            isFetching: false,
            fetchError: true,
            data: null,
        },
    };
    store.setState({
        relatedNews: eventDateRelatedNews,
    });
};

export const fetchPosts = (store, eventTags, eventDateId) => {
    if (!eventTags) return;
    requested(store, eventDateId);

    const { postApiUrl, culture, filterType, productFeature, page, take } =
        store.getState().config;
    const url = `${postApiUrl}/v4/${culture}/post/${filterType}/${productFeature}/${eventTags}/${page}/${take}`;

    fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
    })
        .then((response) => {
            if (response.ok) {
                response
                    .json()
                    .then((values) => received(store, values, eventDateId));
            } else {
                error(store, eventDateId);
            }
        })
        .catch((err) => {
            console.error(err);
            error(store, eventDateId);
        });
};
